import React from 'react';
import { ActualIconProps } from 'mobx/commonTypes';

import IconCloudy from 'icons/weather/iconCloudy';
import IconClear from 'icons/weather/iconClear';
import IconSunCloudy from 'icons/weather/iconSunCloudy';
import IconSemiCloudy from 'icons/weather/iconSemiCloudy';
import IconDrizzle from 'icons/weather/iconDrizzle';
import IconSemiRain from 'icons/weather/iconSemiRain';
import IconRain from 'icons/weather/iconRain';
import IconSemiPowerRain from 'icons/weather/iconSemiPowerRain';
import IconPowerRain from 'icons/weather/iconPowerRain';
import IconPowerTimelessRain from 'icons/weather/iconPowerTimelessRain';
import IconDownpour from 'icons/weather/iconDownpour';
import IconSnowRain from 'icons/weather/iconSnowRain';
import IconSnowLittle from 'icons/weather/iconSnowLittle';
import IconSnow from 'icons/weather/iconSnow';
import IconSnowHard from 'icons/weather/iconSnowHard';
import IconHail from 'icons/weather/iconHail';
import IconThunder from 'icons/weather/iconThunder';
import IconThunderRain from 'icons/weather/iconThunderRain';
import IconThunderHail from 'icons/weather/iconThunderHail';

type WeatherIconWrapperProps = {
  condition: string;
} & ActualIconProps;

export default function WeatherIconWrapper({
  condition,
  sizeKey,
}: WeatherIconWrapperProps) {
  const icons: Record<string, JSX.Element> = {
    'clear': <IconClear sizeKey={sizeKey} />,
    'partly-cloudy': <IconSemiCloudy sizeKey={sizeKey} />,
    'cloudy': <IconSunCloudy sizeKey={sizeKey} />,
    'overcast': <IconCloudy sizeKey={sizeKey} />,
    'drizzle': <IconDrizzle sizeKey={sizeKey} />,
    'light-rain': <IconSemiRain sizeKey={sizeKey} />,
    'rain': <IconRain sizeKey={sizeKey} />,
    'moderate-rain': <IconSemiPowerRain sizeKey={sizeKey} />,
    'heavy-rain': <IconPowerRain sizeKey={sizeKey} />,
    'continuous-heavy-rain': <IconPowerTimelessRain sizeKey={sizeKey} />,
    'showers': <IconDownpour sizeKey={sizeKey} />,
    'wet-snow': <IconSnowRain sizeKey={sizeKey} />,
    'light-snow': <IconSnowLittle sizeKey={sizeKey} />,
    'snow': <IconSnow sizeKey={sizeKey} />,
    'snow-showers': <IconSnowHard sizeKey={sizeKey} />,
    'hail': <IconHail sizeKey={sizeKey} />,
    'thunderstorm': <IconThunder sizeKey={sizeKey} />,
    'thundersworm-with-rain': <IconThunderRain sizeKey={sizeKey} />,
    'thundersworm-with-hail': <IconThunderHail sizeKey={sizeKey} />,
  };

  return icons[condition];
}
